import classNames from 'classnames'
import './GlossaryAlphabet.scss'

const GlossaryAlphabet = ({ glossaryLetters = [] }) => {
  const charArray = [...new Array(26).keys()].map((i) =>
    (i + 10).toString(36).toUpperCase()
  )

  const letterHasContent = (letter) => glossaryLetters.find((i) => i === letter)

  return (
    <section className="c-glossary-alpha__buttons-container">
      {charArray &&
        charArray.map((char, index) => (
          <a
            href={`#${char}`}
            key={index}
            className={classNames(
              'c-glossary-alpha__buttons',
              !letterHasContent(char)
                ? 'c-glossary-alpha-buttons--disabled'
                : undefined
            )}>
            {char}
          </a>
        ))}
    </section>
  )
}

export default GlossaryAlphabet
